var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1729164286006,
    className: "icon",
    viewBox: "0 0 1136 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 27462,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M458.52187 917.027652a458.52187 458.52187 0 1 1 458.521871-458.52187 459.05279 459.05279 0 0 1-458.521871 458.52187z m0-852.689794a394.167924 394.167924 0 1 0 394.167924 394.167924 394.618401 394.618401 0 0 0-394.167924-394.167924z",
    fill: "#8a8a8a",
    "p-id": 27463
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M777.395676 704.804424a54.379085 54.379085 0 0 1 76.725993-5.373554l263.722474 229.116139a54.379085 54.379085 0 0 1 5.373554 76.725993 54.379085 54.379085 0 0 1-76.725993 5.373554l-263.690296-229.116139a54.395173 54.395173 0 0 1-5.405732-76.725993z",
    fill: "#8a8a8a",
    "p-id": 27464
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M608.080442 633.83811a32.048265 32.048265 0 0 1-22.74912-9.427854L306.775264 345.854198a32.176973 32.176973 0 0 1 45.49824-45.514329L630.829563 578.912016a32.176973 32.176973 0 0 1-22.749121 54.926094z",
    fill: "#8a8a8a",
    "p-id": 27465
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M329.524384 633.822021a32.176973 32.176973 0 0 1-22.74912-54.926093l278.572147-278.572147a32.176973 32.176973 0 0 1 45.49824 45.49824L352.273504 624.394168a32.016088 32.016088 0 0 1-22.74912 9.427853z",
    fill: "#8a8a8a",
    "p-id": 27466
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearch);
export default __webpack_public_path__ + "static/media/no-search.0175d0f5af60229733ff14cf37c81717.svg";
export { ForwardRef as ReactComponent };